import { render, staticRenderFns } from "./basketballLeague_common.vue?vue&type=template&id=533b5933"
import script from "./basketballLeague_common.vue?vue&type=script&lang=js"
export * from "./basketballLeague_common.vue?vue&type=script&lang=js"
import style0 from "./basketballLeague_common.vue?vue&type=style&index=0&id=533b5933&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports